
<div>
  <div class="d-flex">
    <app-title-text2 class="remark-title" text="メモ"></app-title-text2>
    <app-link class="mf-2 remark-button" text="編集" @click.native="toggleEditing()"></app-link>
  </div>
  <div class="card-body content-detail-body">
    <div class="content-form-row">
      <div class="tab-content mb-3">
        <div v-if="!isEditing" id="pills-content1" style="white-space: pre-wrap">{{ oldValue }}</div>
        <div v-else id="pills-content2">
          <textarea
            id="customer_remark"
            v-model="value"
            name="customer[remerk]"
            rows="3"
            class="form-control content-textarea"
            placeholder="本文を入力"
          ></textarea>
        </div>
      </div>
      <ul v-if="isEditing" class="nav nav-pills content-detail-nav">
        <li class="nav-item content-detail-nav-item">
          <app-normal-button
            class="active"
            title="キャンセル"
            @click.native="finishEditing()"
          ></app-normal-button>
        </li>
        <li class="nav-item content-detail-nav-item-save">
          <app-primary-button class="active" title="保存" @click.native="save()"></app-primary-button>
        </li>
      </ul>
    </div>
  </div>
</div>
